import { useEffect, useState } from 'react'
import { onUserIdMessage, onSessionIdMessage } from '../utils/sdk-messenger'
import { HEAP_STORAGE_KEY } from 'modules/analytics/plugins/heap'

const CLASSY_SESSION_ID_KEY = 'classy-session-id'

/**
 * Hook that listens for `USER_ID_MSG_TO_APP` and `SESSION_ID_MSG_TO_APP` events.
 * Updates local storage with the user ID for Heap and sets the session ID as `classy-session-id`.
 */
const useUserAndSessionIdUpdater = () => {
  const [didRun, setDidRun] = useState<boolean>(false)

  useEffect(() => {
    const updateHeapUserId = (newUserId: string) => {
      try {
        const heapDataRaw = localStorage.getItem(HEAP_STORAGE_KEY)

        let heapData = heapDataRaw ? JSON.parse(heapDataRaw) : null

        console.log('[Heap] Attempting to update user ID in local storage:', newUserId)

        if (!heapData) {
          // Initialize the Heap storage object if it doesn't exist
          heapData = { value: { userId: newUserId } }

          console.log('[Heap] Initialized new storage with user ID:', newUserId)
        } else if (heapData.value && heapData.value.userId !== newUserId) {
          // Update only if the user ID is different
          heapData.value.userId = newUserId

          console.log('[Heap] Updated user ID in existing storage:', newUserId)
        } else {
          // User ID is already up to date
          return
        }

        localStorage.setItem(HEAP_STORAGE_KEY, JSON.stringify(heapData))
      } catch (error) {
        console.error('[Heap] Failed to update user ID in local storage:', error)
      }
    }

    const setSessionId = (sessionId: string) => {
      try {
        localStorage.setItem(CLASSY_SESSION_ID_KEY, sessionId)

        console.log('[App] Session ID set in local storage:', sessionId)
      } catch (error) {
        console.error('[App] Failed to set session ID in local storage:', error)
      }
    }

    // Attach listeners for user ID and session ID messages
    onUserIdMessage(updateHeapUserId)
    onSessionIdMessage(setSessionId)
    setDidRun(true)
  }, [])

  return didRun
}

export default useUserAndSessionIdUpdater
